<template>
	<div class="zjxheader">
		<div class="zjxheader_center">
			<!-- <img class="zjxheader_img" :src=infoDetail.logo alt=""> -->
			<newNavBar></newNavBar>
			<div class="" style="width: 250px;">
				<el-input style="background: #F2F4F6;" v-model="input" placeholder="请输入内容" @blur="search"
					@keydown.enter.native="seachEnterFun"></el-input>
			</div>
			<div class="handle_bar_login" @click="login" v-if="!user_name">
				<span> 登录 </span>
			</div>
			<div class="handle_bar_register" @click="register" v-if="!user_name">
				<span> 注册 </span>
			</div>

			<div class="zjxheader_center__left" v-show="user_name" @mouseleave="mouseLeave">
				<img :src=user_avatar
					style="width: 21px;height: 20px;margin-top: -2px;border-radius: 50%;margin-left: 50px" alt=""
					v-if="user_name && user_avatar" @mouseover="mouseOver">
				<img src="../assets/img/head.png"
					style="width: 21px;height: 20px;margin-top: -2px;border-radius: 50%;margin-left: 50px" alt=""
					v-if="user_name && !user_avatar" @mouseover="mouseOver">
				<p class="zjxheader_center__left_ps" style="width:80px" @mouseenter="mouseOver">
					<span @click="goInfo">{{user_name}}</span> &nbsp;&nbsp;
				</p>
				<div class="content-head" v-if="display">
					<p class="content" @click="goInfo('order')">我的订单</p>
					<p class="content" @click="goInfo('class')">我的班级</p>
					<p class="content" @click="goInfo('info')">个人信息</p>
					<p class="content" @click="editPwd">修改密码</p>
					<p class="content" style="border-top: 1px solid #ddd;padding-top: 20px" @click="logout">安全退出</p>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import newNavBar from './newNavBar.vue'
	import {
		getBasicInfo
	} from '../api/moudles/user.js'
	export default {
		components: {
			newNavBar,
		},
		data() {
			return {
				infoDetail: {},
				user_name: '',
				input: '',
				display: false,
				user_avatar: '',
			}
		},
		created() {
			let userName = localStorage.getItem('userName')
			let userAvatar = localStorage.getItem('userAvatar')
			this.user_name = userName
			this.user_avatar = userAvatar
			this.getBasicInfo()

			this.$bus.$on('brotherEvent', res => {
				console.log(res)
				let userName = localStorage.getItem('userName')
				let userAvatar = localStorage.getItem('userAvatar')
				this.user_name = userName
				this.user_avatar = userAvatar
				this.getBasicInfo()

			})

		},
		methods: {
			seachEnterFun(e) {
				var keyCode = window.event ? e.keyCode : e.which;
				if (keyCode == 13) {
					this.$router.push({
						path: '/announce/list',
						query: {
							keyword: this.input
						}
					})
				}
			},
			search() {
				this.$router.push({
					path: '/announce/list',
					query: {
						keyword: this.input
					}
				})
			},
			mouseOver() {
				this.display = true
			},
			mouseLeave() {
				this.display = false
			},

			editPwd() {
				this.$router.push('/changepassword')
			},
			goInfo(text) {

				if (text == 'order') {

					this.$router.push({
						path: '/myorder',
						query: {
							text: text
						}
					})

				} else if (text == 'class') {

					this.$router.push({
						path: '/myclass',
						query: {
							text: text
						}
					})

				} else if (text == 'info') {

					this.$router.push({
						path: '/userinfo',
						query: {
							text: text
						}
					})
				}



			},

			logout() {
				localStorage.removeItem('userToken')
				localStorage.removeItem('userName')
				localStorage.removeItem('userAvatar')
				this.$bus.$emit('brotherEvent', 'login')
				this.$router.push({
					path: '/login',
					query: {}
				})

			},

			login() {
				localStorage.removeItem('userToken')
				localStorage.removeItem('userName')
				localStorage.removeItem('userAvatar')
				this.$router.push('/login')
			},

			register() {
				localStorage.removeItem('userToken')
				localStorage.removeItem('userName')
				localStorage.removeItem('userAvatar')
				this.$router.push('/register')
			},

			// 获取基本信息
			async getBasicInfo() {
				await getBasicInfo({
					data: {
						column_code: '5F8B3D07-841C-E204-58D9-3FF4BCEE4765'
					},
					success: res => {
						console.log('基本信息', res)
						this.infoDetail = res.data
					}
				})
			}
		}
	}
</script>

<style scoped>
	.handle_bar_login {
		width: 100px;
		height: 60px;
		color: #0182FD;
		font-weight: bold;
		background-color: #FFF;
		line-height: 60px;
		font-family: PingFangSC-Medium;
		font-size: 16px;
		letter-spacing: 0;
		text-align: center;
		margin-left: 15px;
		cursor: pointer;
	}

	.handle_bar_register {
		font-weight: bold;
		width: 100px;
		height: 60px;
		line-height: 60px;
		font-family: PingFangSC-Medium;
		font-size: 16px;
		color: #FFFFFF;
		letter-spacing: 0;
		text-align: center;
		cursor: pointer;
	}

	.zjxheader {
		height: 60px;
		width: 100%;
		background-color: #0181fc;
		z-index: 998;
		position: sticky;
		position: -webkit-sticky;
		top: 0;
		left: 0;
		display: flex;
		align-items: center;
	}

	.zjxheader_img {
		width: auto;
		height: 44px;
	}

	.zjxheader_center {
		margin-left: auto;
		margin-right: auto;
		width: 1200px;
		height: 60px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.zjxheader_center__left {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.zjxheader_center__left_ps {
		margin-left: 6px;
		height: 54px;
		line-height: 50px;
		text-align: right;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #fff;
		letter-spacing: 0;
		font-weight: 400;
	}


	.content-head {
		position: absolute;
		top: 55px;
		width: 112px;
		background: #ffffff;
		height: 245px;
		border: 1px solid #dddddd;
		font-size: 14px;
		text-align: center;
		line-height: 20px;
		color: #333333;
		cursor: pointer;
	}

	.content {
		margin-top: 20px;
	}
</style>